export const isAdminSelector = (state) => state.AuthenticationReducer.is_admin;
export const currentUserIdSelector = (state) => state.AuthenticationReducer._id;
export const currentUserEmailSelector = (state) => state.AuthenticationReducer.email;
